//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: 'Изменение'
    },
    labelColor: {
      type: String,
      default: 'black'
    },
    placeholder: {
      type: String,
      default: undefined
    },
    // clearable: {
    //   type: Boolean,
    //   default: true
    // },
    // readonly: {
    //   type: Boolean,
    //   default: false
    // },
    hideBottomSpace: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: null
    }
  },
  data: () => {
    return {
      localValue: null
    }
  },
  computed: {
    oldValue: function () {
      return this.localValue && this.localValue.oldValue || null
    },
    newValue: function () {
      return this.localValue && this.localValue.newValue || null
    }
  },
  watch: {
    localValue: function () {
      this.$emit('input', this.localValue)
    }
  },
  created: function () {
    this.localValue = this.value
  },
  mounted: function () {
    this.validate()
  },
  methods: {
    getValueText: function (value) {
      if (value != null) {
        if (Array.isArray(value)) {
          return value.map(valueItem => this.getValueText(valueItem)).filter(valueItemName => !!valueItemName).join(', ')
        } else if (typeof value === 'object') {
          if (value.name != null) {
            return value.name
          }
        }
        return value
      }
      return ''
    },
    validate: function () {
      if (this.$refs.field) {
        return this.$refs.field.validate()
      }
    }
  }
}
